import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "create-organizations" }
const _hoisted_2 = { class: "spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_4 = { for: "stats" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = ["disabled"]

import { computed, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { OrganizationModel } from '@/models/OrganizationModel'
import { toast } from 'vue3-toastify'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { user } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOrganizationsView',
  setup(__props) {

const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const payload = ref<Partial<OrganizationModel>>({})
const isCreatingOrganization = ref(false)

function createOrganization () {
  isCreatingOrganization.value = true

  axios.post('/api/organizations', { ...payload.value, status: payload.value.status ? 'active' : 'inactive' })
    .then(() => {
      toast.success(isChamber.value ? 'Câmara criada com sucesso' : 'Setor criado com sucesso')
      payload.value = {}
    })
    .finally(() => isCreatingOrganization.value = false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("h1", null, [
        _createElementVNode("strong", null, "Crie um " + _toDisplayString(isChamber.value ? 'câmara' : 'setor'), 1),
        _createTextVNode(" (obrigatório)")
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Ex: Secretaria de Segurança e Trânsito",
        name: "name",
        id: "namet",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event))
      }, null, 512), [
        [_vModelText, payload.value.name]
      ])
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("h1", null, [
        _createElementVNode("strong", null, "Iniciais do " + _toDisplayString(isChamber.value ? 'câmara' : 'setor'), 1),
        _createTextVNode(" (obrigatório)")
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Ex: S.M.S.T",
        name: "acronym",
        id: "acronym",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.acronym) = $event))
      }, null, 512), [
        [_vModelText, payload.value.acronym]
      ])
    ]),
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          name: "stats",
          id: "stats",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.status) = $event))
        }, null, 512), [
          [_vModelCheckbox, payload.value.status]
        ]),
        _hoisted_5
      ])
    ]),
    _createElementVNode("nav", null, [
      (!isCreatingOrganization.value)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "button",
            value: "Criar",
            onClick: createOrganization,
            disabled: !payload.value.name || !payload.value.acronym
          }, null, 8, _hoisted_6))
        : (_openBlock(), _createBlock(SpinnerLoaderButton, {
            key: 1,
            height: 60,
            maxWidth: 464
          })),
      _createElementVNode("input", {
        type: "button",
        value: "Cancelar",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.go(-1)))
      })
    ])
  ]))
}
}

})